module.exports = __webpack_public_path__ + "img/pile1.9d2f9048.png";